import {Apollo} from 'apollo-angular';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';

import {KpiAnalyticsScheduleModel} from '../models/kpi-analytics-schedule.model';
import {PlaningEventCategoryColorPipe} from '../../../pipes/planing-event-category-color/planing-event-category-color.pipe';
import {ProcessDetailScheduleGQL, ProcessDetailScheduleQuery} from '../../graphql';
import {TClassBlockColorPipe} from '../../../pipes/tclass-block-color/tclass-block-color.pipe';

@Injectable({
  providedIn: 'root'
})
export class ProcessDetailScheduleService {
  constructor(private apollo: Apollo,
              private planingEventCategoryColorPipe: PlaningEventCategoryColorPipe,
              private tClassBlockColorPipe: TClassBlockColorPipe,
              private processDetailScheduleGQL: ProcessDetailScheduleGQL) {
  }

  public getProcessScheduleData(startRange: number, endRange: number,
                                plannedEventsIds: string[], tclassBlocksIds: string[]): Observable<KpiAnalyticsScheduleModel> {
    return this.apollo.use('v2_http').query({
      query: this.processDetailScheduleGQL.document,
      variables: {startRange: endRange, endRange: startRange,
                  plannedEvents: plannedEventsIds, tclassBlocks: tclassBlocksIds},
      fetchPolicy: 'no-cache'
    }).pipe(map((e: Apollo.QueryResult<ProcessDetailScheduleQuery>) =>
        KpiAnalyticsScheduleModel.mapProcessSchedule(e.data, this.planingEventCategoryColorPipe, this.tClassBlockColorPipe)
    ));
  }
}
